export default __webpack_public_path__ + "static/media/IMG_2138.320a9239.JPG";